<template>
  <div v-loading="tableLoading" class="my-table">
    <el-table
      id="out-table"
      ref="table"
      style="width: 100%"
      size="mini"
      :data="
        (getData ?
          show_table_list_data :
          show_table_list_data.slice((currentPage - 1) * page_size, currentPage * page_size))
      "
      :row-key="getRowKeys"
      v-bind="getProps(tableProps, default_table_props)"
      v-on="getProps(tableOn, default_table_on)"
    >
      <!-- 数据勾选 -->
      <el-table-column
        v-if="check"
        type="selection"
        align="center"
        width="55"
        :selectable="checkSelectable"
      />
      <el-table-column
        v-if="expand"
        type="expand"
        width="30px"
      >
        <template slot-scope="props">
          <app-table-cell :value="expandTemplate(props.row) ? expandTemplate(props.row): props.row" />
        </template>
      </el-table-column>
      <template v-for="(item, key) in tableKey">
        <!-- 表格数据 -->
        <el-table-column
          :key="key"
          v-bind="getProps(item.props, default_table_column_props(item, key))"
          v-on="item.on ? item.on : null"
        >
          <el-table-column
            v-for="(s_item, s_key) in item.children"
            :key="`${s_item.value}_${s_key}`"
            v-bind="getProps(s_item.props, default_table_column_props(s_item, s_key))"
            v-on="s_item.on ? s_item.on : null"
          />
        </el-table-column>
      </template>
      <template #empty>
        <slot name="empty" />
      </template>
    </el-table>
    <!-- 分页 -->
    <div style="text-align: center">
      <el-pagination
        v-if="isCurrentPage"
        name="fenye"
        :layout="paginationLayout"
        :current-page.sync="currentPage"
        :page-sizes="(pageSizes && pageSizes.length) ? pageSizes : [10, 15, 20]"
        :page-size="pageSize?pageSize:10"
        :total="total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>
<script>
export default {
  components: {
    'app-table-cell': () => import('./app-table-cell'),
  },
  props: {
    tableId: {
      type: Number,
      default: 0,
    },
    // 表格key值
    tableKey: {
      type: Array,
      default: () => {
        return [];
      },
    },
    // 表格参数
    tablep: {
      type: Object,
      default: () => {
        return {};
      },
    },
    // 是否打开展开详细页
    expand: {
      type: Boolean,
      default: false,
    },
    // 扩展模板
    expandTemplate: {
      type: Function,
      default: () => {},
    },
    // 是否保留勾选
    isReserveChecked: {
      type: Boolean,
      default: true,
    },
    // 勾选组件
    check: {
      type: Boolean,
      default: false,
    },
    // 勾选key
    checkKey: {
      type: String,
      default: 'id',
    },
    // 是否为单选
    isRadio: {
      type: Boolean,
      default: false,
    },
    detailList: {
      type: Array,
      default: () => {
        return [];
      },
    },
    // 是否点击行也选中
    isRowClick: {
      type: Boolean,
      default: false,
    },
    // 请求数据方法
    getData: {
      type: Function,
      default: null,
    },
    // 勾选是否禁用方法
    checkSelectable: {
      type: Function,
      default: () => {
        return true;
      },
    },
    // 表格列表数据
    tableListData: {
      type: [Object, Array],
      default: () => {
        return null;
      },
    },
    // 每页条数
    pageSize: {
      type: Number,
      default: () => {
        return 10;
      },
    },
    // 页数列表
    pageSizes: {
      type: Array,
      default: () => {
        return [];
      },
    },
    // 表格属性
    tableProps: {
      type: Object,
      default: () => {
        return {};
      },
    },
    // 表格事件
    tableOn: {
      type: Object,
      default: () => {
        return {};
      },
    },
    // 是否分页
    isCurrentPage: {
      type: Boolean,
      default: () => {
        return true;
      },
    },
    // 默认是否请求
    isRequest: {
      type: Boolean,
      default: true,
    },
    // 搜索
    search: {
      type: String,
      default: '',
    },
    // 搜索键值
    searchKey: {
      type: String,
      default: 'name',
    },
    // 分页布局
    paginationLayout: {
      type: String,
      default: 'total, sizes, prev, pager, next, jumper',
    },
  },
  data() {
    return {
      // 数据
      datapar: [],
      uploadId: '', // 上传ID
      tblepar: false,
      tableData: [],
      uploadImageOff: false,
      showImageOff: false,
      view: {},
      operateWidth: 0,
      // 获取row的key值
      getRowKeys: (row) => {
        return row[this.checkKey];
      },
      expandModels: {},
      expands: [], // 要展开的行，数值的元素是row的key值
      tableLoading: false,
      currentPage: 1, // 当前页
      page_size: this.pageSize, // 一页显示数据条数
      tableProp: this.tablep.prop,
      tableOrder: this.tablep.order, // 排序方式
      sort: 1, // 排序
      total: 0, // 总数据
      multipleSelection: [], // 当前选中用到数据
      multipleSelectionAll: [], // 所有选中的数据包含跨页数据
      idKey: 'barcode', // 标识列表数据中每一行的唯一键的名称
      // 默认表格属性
      default_table_props: {
        'id': 'out-table',
        'style': 'width: 100%',
        'size': 'mini',
        'default-sort': {
          prop: this.tableProp,
          order: this.tableOrder,
        },
        'highlight-current-row': true,
        'tooltip-effect': 'dark',
        'expand-row-keys': this.expands,
        'border': true,
      },
      // 默认表格事件
      default_table_on: {
        'sort-change': this.changes,
        'expand-change': this.expandChange,
        'row-click': this.expandChange,
        'select-all': this.onSelectAll,
        'select': this.setSelectRow,
      },
      // 默认表格列属性
      default_table_column_props: (item, key) => {
        return {
          'show-overflow-tooltip': item.hasOwnProperty('overflow') ? item.overflow : true,
          fixed: item.fixed ? item.fixed : false,
          width: item.width ? item.width : false,
          prop: item.value,
          index: key,
          item: item,
          label: item.name,
          align: item.align ? item.align : null,
          formatter: item.format,
          'render-header': this.checkAllColumns,
          'reserve-selection': true,
        };
      },
    };
  },
  computed: {
    show_table_list_data: function() {
      return this.tableData.filter(data => !this.search || data[this.searchKey].toLowerCase().includes(this.search.toLowerCase()));
    },
  },
  watch: {
    show_table_list_data: function() {
      // 列表变化更新总数
      this.total = this.getData ? this.total : this.show_table_list_data.length;
    },
  },
  mounted() {
    if (this.isRequest) {
      this.tableChang();
    }
  },
  methods: {
    // table排序触发
    changes({ column, prop, order }) {
      this.tableProp = prop;
      this.tableOrder = order;
      if (order !== 'descending') {
        this.sort = 0;
      } else {
        this.sort = 1;
      }
      return false;
    },
    // 表格搜索
    seekTable() {
      this.currentPage = 1;
      this.tablep.page = this.currentPage;
      this.tableChang();
    },

    // 刷新表格
    refer() {
      this.tableChang();
    },

    expandChange(row) {
      if (this.isRowClick){
        this.setRowClick(row);
      }
      // 展开详细页
      if (this.expand) {
        const temp = this.expands;
        this.expands = [];
        this.expands.push(row[this.checkKey]);
        if (temp.length === 1 && temp[0] === row.id) {
          // 收起展开行
          this.expands = [];
        } else {
          this.expandModels = row;
        }
      }
    },

    // 点击行也选中
    setRowClick(row){
      const isSelect = !this.multipleSelection.find(e => row[this.checkKey] === e[this.checkKey]);
      // 如果未选中
      if (isSelect){
        this.multipleSelection.push(row);
      } else {
        // 选中的数组中删除该行
        this.multipleSelection = this.multipleSelection.filter(item => {
          return item[this.checkKey] !== row[this.checkKey];
        });
      }
      this.$refs.table.toggleRowSelection(row, isSelect);
      this.changePageCoreRecordData();
      this.$emit('select-tr', this.multipleSelection);
    },

    // 修改每页条数触发
    handleSizeChange(val) {
      this.currentPage = 1;
      this.tablep.page = this.currentPage;
      this.page_size = val;
      this.tablep.limit = this.page_size;
      this.tableChang();
    },

    // 翻页触发
    handleCurrentChange(val) {
      this.currentPage = val;
      this.tablep.page = this.currentPage;
      this.tableChang();
    },

    // 表格回调函数
    listCallBack(res) {
      this.isCurrentPage ? this.tableData = res.list : this.tableData = res;
      this.total = res?.page_info?.total_number;
      this.tableLoading = false;
      if (this.isReserveChecked){
        this.selectedPreExisting(this.multipleSelection);
      }
    },

    // 选中table已有数据
    selectedPreExisting(rows, isSelect) {
      if (rows.length > 0) {
        // 这里使用this.$nextTick是防止表格未渲染完成就执行，导致无法添加选中效果
        this.$nextTick(() => {
          rows.forEach(row => {
            // 判断row是存在当前tableData
            const selectedItem = this.tableData.find(item => item[this.checkKey] === row[this.checkKey]);
            selectedItem ? (typeof isSelect !== 'undefined' ? this.$refs.table.toggleRowSelection(selectedItem, isSelect) : this.$refs.table.toggleRowSelection(selectedItem)) : '';
          });
        });
      } else {
        this.$refs.table.clearSelection();
      }
    },

    // 更新table数据
    tableChang() {
      if (this.detailList.length !== 0) {
        var cont = 0;
        for (var i = 0; i < this.detailList.length; i++) {
          if (this.detailList[i].hidden === true) {
            cont++;
          }
          this.operateWidth = cont * 100;
        }
      }
      this.tableLoading = true;

      if (this.getData) {
        this.getData(this.tablep).then((res) => {
          this.listCallBack(res);
        }).catch(() => {
          this.tableLoading = false;
        });
      } else if (this.tableListData) {
        if (this.tableListData.page_info) {
          this.tableListData.page_info.total_number = this.tableListData.list.length;
        }

        this.listCallBack(this.tableListData);
      }
    },

    // 选中所有
    onSelectAll(selection) {
      if (!selection || selection.length === 0) {
        this.isReserveChecked ? this.deleteRows(this.tableData) : this.multipleSelection = [];
        this.$emit('select-tr', this.multipleSelection);
        return;
      }
      if (this.isRadio) {
        this.$refs.table.clearSelection();
      } else {
        if (!this.isReserveChecked){
          this.multipleSelection = selection;
        } else {
          this.addRows(this.tableData);
        }
      }

      this.changePageCoreRecordData();
      this.$emit('select-tr', this.multipleSelection);
    },

    // 设置选中行
    setSelectRow(selection, row) {
      let isSelect = !this.multipleSelection.find(e => row[this.checkKey] === e[this.checkKey]);
      if (!isSelect){
        this.multipleSelection = this.multipleSelection.filter(item => {
          return item[this.checkKey] !== row[this.checkKey];
        });
      } else {
        if (this.isRadio) {
          isSelect = true;
          this.$refs.table.clearSelection();
          this.multipleSelection = [row];
        } else {
          if (!this.isReserveChecked){
            this.multipleSelection = selection;
          } else {
            // 翻页保留选项
            if (selection && selection.find(item => item && (item === row))) {
              this.addRows([row]);
            } else {
              this.deleteRows([row]);
            }
          }
        }
      }
      this.$refs.table.toggleRowSelection(row, isSelect);
      this.changePageCoreRecordData();
      this.$emit('select-tr', this.multipleSelection);
    },
    changePageCoreRecordData() {
      if (this.multipleSelectionAll.length <= 0) {
        this.multipleSelectionAll = this.multipleSelection;
        return;
      }
    },

    // 添加选中
    addRows(rows) {
      rows.forEach(row => {
        this.multipleSelection.push(row);
      });

      const map = new Map();
      for (const item of this.multipleSelection) {
        if (!map.has(item[this.checkKey])) {
          map.set(item[this.checkKey], item);
        }
      }
      this.multipleSelection = [...map.values()];
    },

    // 取消选中
    deleteRows(rows) {
      // 当selectedItems为空数组时，不执行删除
      if (this.multipleSelection.length === 0) {
        return;
      }
      rows.forEach(row => {
        this.multipleSelection = this.multipleSelection.filter(item => row[this.checkKey] !== item[this.checkKey]);
      });
    },
    // 全部选中当前列
    handleCheckAllChange(check, key) {
      const cityOptions = this.tableData.map((row) => {
        return row[key];
      });
      check.checked_list = check.checkAll ? cityOptions : [];
      check.isIndeterminate = false;
    },
    checkAllColumns(h, { column, $index }) {
      const s = this;
      const item = this.tableKey[$index];
      let ele = '';
      if (item && item.check) {
        ele = h('div', null, [
          h(
            'el-checkbox',
            {
              props: {
                indeterminate: item.check.isIndeterminate,
                label: column.label,
                value: item.check.checkAll,
              },
              on: {
                change: (val) => {
                  item.check.checkAll = val;
                  s.handleCheckAllChange(item.check, item.value);
                },
              },
            },
            column.label
          ),
          item.operationFunc ? h('el-button', {
            style: {
              margin: '0 10px',
            },
            props: {
              circle: true,
              icon: 'el-icon-s-operation',
              size: 'mini',
            },
            on: {
              click: () => {
                if (item.operationFunc) {
                  item.operationFunc(
                    item.check.checked_list,
                    item.value,
                    s.tableId
                  );
                }
              },
            },
          }) : null,
        ]);
      } else {
        ele = column.label;
      }

      return ele;
    },
    // 获取props
    getProps: function(new_obj, old_obj) {
      return { ...old_obj, ...new_obj };
    },
  },
};
</script>

<style >
.my-table .el-table {
  text-align: center;
  font-size: 12px;
}
.my-table .el-table .cell {
  overflow: hidden;
  text-overflow: ellipsis;
}
.my-table .el-checkbox__label {
  font-size: 12px;
}
.my-table .el-pagination {
  margin-top: 30px;
}
.my-table .list-header {
  background: #119dd7;
}
.my-table .expand-box {
  border-top: 3px #dbdbdb solid;
  border-bottom: 3px #dbdbdb solid;
  padding: 0 10px;
}
.my-table .el-table__expanded-cell[class*='cell'] {
  padding: 0;
}

.my-table .detailButton {
  margin: 10px;
}
</style>
